<template>
  <div class="search-container">
    <Input :InputAndActiveType='activeType' />
    <ul class="nav">
      <li
        v-for="item in navList"
        :key="item.articleType"
        :class="{ active: activeType === item.articleType }"
        @click="tagChange(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <components :is="isShow ? isShow : All" :type="type"></components>
  </div>
</template>

<script>
import All from "./view/all.vue";
import Info from "./view/information.vue";
import Paper from "./view/Paper.vue";
// import Abstract from "./view/Abstract.vue";
// import SearchVideo from "./view/SearchVideo.vue";
import Monograph from "./view/Monograph.vue";
// import Report from "./view/Report.vue";
import SearchSub from "./view/SearchSub.vue";
import Organ from "./view/Organ.vue";
import Meeting from "./view/Meeting.vue";
import Course from "./view/Course.vue";
import Input from '@/views/PCView/search/components/Input.vue'
export default {
  components:{
    Input
  },
  data() {
    return {
      activeType: 999,
      isShow: All,
      navList: [
        { articleType: 999, name: "全部", components: All },
        { articleType: 0, name: "论文", components: Paper },
        { articleType: 5, name: "资讯", components: Info },
        { articleType: 2, name: "专著", components: Monograph },
        // { articleType: 7, name: "视频", components: SearchVideo },
        // { articleType: 6, name: "行业报告", components: Report },
        { articleType: 8, name: "会议", components: Meeting },
        { articleType: 9, name: "课程", components: Course },
        // { articleType: 21, name: "用户", components: SearchSub },
        { articleType: 1, name: "学者", components: SearchSub, type: 2 },
        { articleType: 3, name: "期刊", components: SearchSub, type: 4 },
        { articleType: 4, name: "机构", components: SearchSub, type: 5 },
        { articleType: 22, name: "名录", components: Organ },
      ],
      type: 0,
    };
  },
  created() {
    if (this.$route.query.articleType) {
      let arr = this.navList.filter((item) => item.articleType == this.$route.query.articleType);
      this.isShow = arr[0].components;
      this.activeType = arr[0].articleType;
      this.type = arr[0].type ? arr[0].type : 0
      sessionStorage.setItem('InputAndActiveType',this.activeType) // 存储当前栏目id
    }
    // 如果存在栏目id,则代表用户想要在当前栏目点击下拉不同类型进行二次搜索
    if (sessionStorage.getItem('InputAndActiveType')){
      let arr = this.navList.filter((item) => item.articleType == sessionStorage.getItem('InputAndActiveType'));
      this.isShow = arr[0].components;
      this.activeType = arr[0].articleType;
      this.type = arr[0].type ? arr[0].type : 0
    }
  },
  methods: {
    // 搜索栏目切换
    tagChange(obj) {
      this.activeType = obj.articleType;
      this.isShow = obj.components;
      this.type = obj.type ? obj.type : 0
      sessionStorage.setItem('InputAndActiveType',this.activeType) // 存储当前栏目id
      sessionStorage.setItem('searchType',true) // 存储一个标识
      sessionStorage.removeItem('indexs')
      if(this.activeType == 1 || this.activeType == 3 ||  this.activeType == 4 || this.activeType == 22  ){
        this.$router.push({ // 初始化当前路由参数
          query:{
            paramStr:this.$route.query.paramStr,
            searchType:'name'
          }
        })
      }else{ // 非用户类
        this.$router.push({ // 初始化当前路由参数
          query:{
            paramStr:this.$route.query.paramStr,
            searchType:'title'
          }
        })
      }
    },
  },
  beforeDestroy() {
    if(!this.$route.query.searchType){
      sessionStorage.removeItem('InputAndActiveType')
      sessionStorage.removeItem('searchType')
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  margin-top: 0;
  &:not(:first-child) {
    margin-top: 10px;
  }
}
.search-container {
  margin-top: 22px;
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 47px;
    border-bottom: 3px solid #0b35c5;
    li {
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      color: #333333;
      cursor: pointer;
      &.active {
        color: #0b35c5;
        font-weight: 700;
      }
    }
  }
}
</style>
